import { useDecision } from '@optimizely/react-sdk';
import { BEYOND_WEB_PRESENCE } from '@/src/constants/feature-flags';

export const useBeyondWebTestVariant = () => {
  const [beyondWebPresence] = useDecision(BEYOND_WEB_PRESENCE);
  return beyondWebPresence
    ? beyondWebPresence.variationKey === 'rewards'
      ? 'Rewards'
      : 'Beyond'
    : null;
};
